<template>
    <span class="humanReadableRuleDescription">
        <template v-if="RelationIsSpecial(rule.relation)">
            <template v-if="rule.relation === 'hours_between_same_order'">
                <span>Er zijn <strong>{{rule.value}}</strong> uur of minder tussen twee bestellingen van dezelfde klant</span>
            </template>

            <template v-else-if="rule.relation === 'sales_order_lines'">
                <span>Er is een orderregel met een <strong>aantal dat {{mapObjectKey(Operators, rule.operator)}} {{rule.value}}</strong></span>
            </template>

            <template v-else-if="rule.relation === 'different_billing_and_shippping_address'">
                <span>De factuur- en afleveradres zijn verschillend</span>
            </template>

            <template v-else-if="rule.relation === 'total_price'">
                <span>Het <strong>totaalbedrag</strong> van de order <strong>{{ mapObjectKey(Operators, rule.operator) }} {{rule.value}} euro</strong></span>
            </template>

            <template v-else>
                <strong>{{ mapObjectKey(Relations, rule.relation).toLowerCase() }}</strong>
                {{ mapObjectKey(Operators, rule.operator) }} <strong>{{ ValueFormatter({operator: rule.operator, value: rule.value}) }}</strong>
            </template>
        </template>

        <template v-else>
            uit <strong>{{ mapObjectKey(Relations, rule.relation).toLowerCase() }}</strong>
            de waarde van <strong>{{ mapObjectKey(Fields, rule.field).toLowerCase() }}</strong>
            {{ mapObjectKey(Operators, rule.operator) }}: <strong>{{ ValueFormatter({operator: rule.operator, value: rule.value}) }}</strong>
        </template>
    </span>
    
</template>

<script>
import { Fields, Operators, Relations, ValueFormatter, SpecialRelations, RelationIsSpecial } from '@/data/holdRules';
import { mapObjectKey } from '@/helpers/mappings';
export default {
    name: "GroupRule",
    props: {
        rule: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            Relations,
            Fields,
            Operators,
            SpecialRelations
        }
    },
    methods: {
        mapObjectKey,
        ValueFormatter,
        RelationIsSpecial
    }
}
</script>